export default __webpack_public_path__ + "static/media/pizzaneptune.cc91e15e.jpg";